
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import subcontractService from '../../services/subcontractService';

export const fetchContractors = createAsyncThunk('subcontract/fetchContractors', async (_, { getState }) => {
  return await subcontractService.getContractors(getState().auth.token);
});
export const fetchContractorEmployees = createAsyncThunk('subcontract/fetchEmployees', async (_, { getState }) => {
  return await subcontractService.getContractorEmployees(getState().auth.token);
});
export const createContractor = createAsyncThunk('subcontract/createContractor', async (data, { getState }) => {
  return await subcontractService.createContractor(data, getState().auth.token);
});

const subcontractSlice = createSlice({
  name: 'subcontract',
  initialState: {
    contractors: [], contractorEmployees: [],
    loading: false, error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractors.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchContractors.fulfilled, (state, action) => { state.loading = false; state.contractors = action.payload; })
      .addCase(fetchContractors.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchContractorEmployees.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchContractorEmployees.fulfilled, (state, action) => { state.loading = false; state.contractorEmployees = action.payload; })
      .addCase(fetchContractorEmployees.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createContractor.fulfilled, (state, action) => { state.contractors.unshift(action.payload); });
  },
});

export default subcontractSlice.reducer;
